import { lazy } from "react";

export const ThemeFormSubHeader = lazy(() => import("./ThemeFormSubHeader"));
